import { createSelector } from 'reselect';

const getTags = state => state.tags.data;

/**
  @name getTagsCount
  Selector to obtain the total tags count of selected site
*/
const getTagsCount = createSelector(
  [getTags],
  (tags) => tags.length
);

export default getTagsCount;



// WEBPACK FOOTER //
// ./src/utils/selectors/getTagsCount.js